import { DealMetricsState } from './state';
import { DealMetricsActionsUnion, DealMetricsActionTypes } from './actions';

export const initialDealMetricsState: DealMetricsState = {
  dealId: undefined,
  rating: undefined,
  score: undefined,
  status: undefined,
  ownership: undefined,
  error: undefined,
  loaded: false,
  loading: false,
  saving: false,
  savingError: undefined
};

export function dealMetricsReducer(
  state: DealMetricsState = initialDealMetricsState,
  action: DealMetricsActionsUnion
) {
  switch (action.type) {
    case DealMetricsActionTypes.Load:
      return {
        ...state,
        dealId: action.payload,
        error: undefined,
        savingError: undefined,
        saving: false,
        loaded: false,
        loading: true,
        rating: undefined,
        score: undefined,
        status: undefined,
        ownership: undefined
      };
    case DealMetricsActionTypes.LoadSuccess:
      return {
        ...state,
        error: undefined,
        loaded: true,
        loading: false,
        rating: action.payload.internalRating,
        score: action.payload.internalScore,
        status: action.payload.internalStatus,
        ownership: action.payload.ownership
      };
    case DealMetricsActionTypes.LoadFail:
      return {
        ...state,
        error: action.payload,
        loaded: false,
        loading: false,
        rating: undefined,
        score: undefined,
        status: undefined,
        ownership: undefined
      };
    case DealMetricsActionTypes.SaveScore:
      return {
        ...state,
        saving: true,
        score:
          action.payload.dealId === state.dealId
            ? action.payload.score
            : state.score,
        savingError: undefined
      };
    case DealMetricsActionTypes.SaveScoreSuccess:
      return {
        ...state,
        saving: false
      };
    case DealMetricsActionTypes.SaveScoreFail:
      return {
        ...state,
        saving: false,
        score:
          action.payload.dealId === state.dealId
            ? action.payload.score
            : state.score,
        savingError: action.payload.error
      };
    case DealMetricsActionTypes.SaveRating:
      return {
        ...state,
        saving: true,
        rating:
          action.payload.dealId === state.dealId
            ? action.payload.rating
            : state.rating,
        savingError: undefined
      };
    case DealMetricsActionTypes.SaveRatingSuccess:
      return {
        ...state,
        saving: false
      };
    case DealMetricsActionTypes.SaveRatingFail:
      return {
        ...state,
        saving: false,
        rating:
          action.payload.dealId === state.dealId
            ? action.payload.rating
            : state.rating,
        savingError: action.payload.error
      };
    case DealMetricsActionTypes.SaveOwnership:
      return {
        ...state,
        saving: true,
        ownership:
          action.payload.dealId === state.dealId
            ? action.payload.ownership
            : state.ownership,
        savingError: undefined
      };
    case DealMetricsActionTypes.SaveOwnershipSuccess:
      return {
        ...state,
        saving: false
      };
    case DealMetricsActionTypes.SaveOwnershipFail:
      return {
        ...state,
        saving: false,
        ownership:
          action.payload.dealId === state.dealId
            ? action.payload.ownership
            : state.ownership,
        savingError: action.payload.error
      };
    case DealMetricsActionTypes.SaveStatus:
      return {
        ...state,
        saving: true,
        status:
          action.payload.dealId === state.dealId
            ? action.payload.status
            : state.status,
        savingError: undefined
      };
    case DealMetricsActionTypes.SaveStatusSuccess:
      return {
        ...state,
        saving: false
      };
    case DealMetricsActionTypes.SaveStatusFail:
      return {
        ...state,
        saving: false,
        status:
          action.payload.dealId === state.dealId
            ? action.payload.status
            : state.status,
        savingError: action.payload.error
      };
    default:
      return state;
  }
}
